import { graphql } from "../gql";

export const User1on1ClassroomPlanToBeRedeemedFragment = graphql(`
  fragment User1on1ClassroomPlanToBeRedeemed on User1on1ClassroomPlanToBeRedeemedGraphqlDto {
    id
    createdAt
    user {
      id
      familyName
      givenName
      email
    }
    totalNumberOfLessons
    createdPlanId
  }
`);
